const translations = {
    customerMemoPlaceholder: 'Note to Customer (displayed on invoice)',
    discountAmount: 'Discount Amount',
    discountPercentage: 'Discount %',
    discountType: 'Discount Type',
    productUsageReport: 'Product Usage Report Application Date',
    shipping: 'Shipping',
    taxCodesDropdown: 'Sales Tax %',
    workOrderNumber: 'Work Order #'
};

export default translations;
